import { render } from "./admin-component.vue?vue&type=template&id=517ae884"
import script from "./admin-component.vue?vue&type=script&lang=js"
export * from "./admin-component.vue?vue&type=script&lang=js"

import exportComponent from "D:\\playground\\canada-cars\\Kia\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__